import React, { Fragment } from "react";

/**
 * Full-screen blocking loader.
 *
 * The mark is drawn in CSS rather than imported as an SVG so it inherits the
 * theme tokens (accent, border, surface) and changes with dark/light. The
 * previous asset was a fixed-palette loading.io bars animation in #1d3f72,
 * which ignored the theme and read as stock.
 *
 * Outer id/className are unchanged so anything targeting them still matches.
 * Styles live in theme-minimal.css, which loads after App.css and so beats
 * its `background: #111 !important` on the overlay.
 */
export default class Loader extends React.Component {
  render() {
    return (
      <Fragment>
        <div
          id="WIP_loader"
          style={{ display: this.props.show ? "block" : "none" }}
          className="lodr-overlay"
          role="status"
          aria-live="polite"
          aria-busy={this.props.show ? "true" : "false"}
        >
          <div className="gif-loader">
            <span className="ldr-ring" aria-hidden="true" />
            <p>Loading</p>
          </div>
        </div>
      </Fragment>
    );
  }
}
